import React from 'react';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';
import ButtonIcon from 'cyder/button/ButtonIcon';
import history from '../../history';
import MembershipIssuanceAnalyticsToolbar from 'pages/analytics/components/membership-issuance/MembershipIssuanceAnalyticsToolbar';
import MembershipIssuedChart from 'pages/analytics/components/membership-issuance/MembershipIssuedChart';
import { Row, Col, Container } from 'reactstrap';
import StaffCompanySearch from 'elements/navbar-staff/Search';

var buttonStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
};

const AnalyticsButton = ({ btnProps, colStyle, onClick, label, check }) => {
    let buttonColor = null;
    let fontColor = null;
    if (check) {
        buttonColor = 'grey';
        fontColor = 'white';
    }
    // console.log("buttonColor: ", buttonColor, ", check: ", check);
    return (
        <Row style={{ marginBottom: '5px' }}>
            <Col style={colStyle}>
                <ButtonIcon label={label} onClick={onClick} {...btnProps} buttonColor={buttonColor} fontColor={fontColor} />
            </Col>
        </Row>
    );
};

class MembershipIssuedAnalytics extends React.Component {
    render() {
        return (
            <Container>
                <Row style={{ marginBottom: '20px' }}>
                    <Col xs={4}>
                        <StaffCompanySearch />
                    </Col>
                    <Col xs={8}>
                        <Row className="float-right">
                            <AnalyticsButton
                                colStyle={buttonStyle}
                                onClick={e => {
                                    history.push('/staff/analytics/membership');
                                }}
                                label="Membership Analytics"
                            />
                            <AnalyticsButton
                                colStyle={buttonStyle}
                                onClick={e => {
                                    history.push('/staff/analytics/membership/renewalanalytics');
                                }}
                                label="Renewal Analytics"
                            />
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginBottom: '20px' }}>
                    <Col xs={12}>
                        <MembershipIssuanceAnalyticsToolbar />
                    </Col>
                </Row>
                <Row style={{ marginBottom: '20px' }}>
                    <Col xs={12}>
                        <MembershipIssuedChart />
                    </Col>
                </Row>
            </Container>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(MembershipIssuedAnalytics));
